import { FC } from "react";

interface IProps {
  header: string;
}

export const AddRecipientHeader: FC<IProps> = ({ header }) => {
  return <div className="add-recipient__header"><div className="add-recipient__heading">{header}</div></div>;
};
